import {debugLog} from "../Utils/LogUtils";
import {useEffect} from 'react';
import {isCLBOnlyAllowed, PLAN_TYPE_IDS} from '../Utils/PlanUtils';

//CLB Only is only an option for the SI plan. If the user selects a different plan, we need to reset the CLB Only option
export default function useEnforceCLBOnlyAllowed(state) {
    useEffect(() => {
        if (!state.enrollment.state) { return; }
        if (!isCLBOnlyAllowed(state) && state.plan.clbOnly) {
            state.setPlan(prevData => ({...prevData, clbOnly: false}));
        }
        debugLog("useEnforceCLBOnlyAllowed");
    }, [state.plan.planTypeID]);
}